import { object, string, number } from "yup";

export const NewCitySchema = object({
  name: string().required("Задолжително"),
  latitude: number(),
  longitude: number(),
  zoom: number(),
});
